module.exports = __webpack_public_path__ + "static/media/img17.cd3ff209.jpg";